__turbopack_context__.v({
  "caption": "J4B-UW_caption",
  "card": "J4B-UW_card",
  "frame": "J4B-UW_frame",
  "placeholder": "J4B-UW_placeholder",
  "play": "J4B-UW_play",
  "player": "J4B-UW_player",
  "poster": "J4B-UW_poster",
  "rail": "J4B-UW_rail",
  "scrim": "J4B-UW_scrim",
  "section": "J4B-UW_section",
  "thumb": "J4B-UW_thumb",
});
